import Axios from 'axios'
import { OAUTH_API } from '@/services/Configuration'
import { error } from '../Log'

const Orders = {
  getCustomerOrders: async ({ sort = 'date_created:desc' } = {}) => {
    try {
      const headers = {
        'Content-Type': 'application/json',
      }
      const { data: { data } } = (await Axios.post(`${OAUTH_API}/sf/customer/order/`,
        { sort }, { headers }))
      return data
    } catch (err) {
      error('Failed to retrieve the customer orders', { error: err })
    }
    return []
  },
}

export default Orders
